import type { Ref } from "vue";
import type { CultureDto, HeadlessItem } from "../types";
import { useState } from "#imports";

export type HeadlessItemError = {
  statusCode?: number;
  statusMessage?: string;
  cause?: Error;
  data?: any;
};
export const useHeadlessDataState = (): Ref<HeadlessItem | null> => useState<HeadlessItem | null>( "headless", () => null );

export const useHeadlessDataErrorState = (): Ref<HeadlessItemError | null> => useState<HeadlessItemError | null>( "headless-error", () => null );

export const useHeadlessCultureState = (): Ref<string | null> => useState<string | null>( "culture", () => null );

export const useHeadlessCultureListState = (): Ref<CultureDto[] | null> => useState<CultureDto[] | null>( "culturesList", () => null );
